export default "__VITE_ASSET__CfHmMV5C__"